/**
 * @generated SignedSource<<ba83acf525ed3bd6735e74516af1c506>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodPixSelected_charge$data = {
  readonly brCode: string | null | undefined;
  readonly company: {
    readonly logo: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly customer: {
    readonly id: string;
  } | null | undefined;
  readonly customerRegister: boolean | null | undefined;
  readonly id: string;
  readonly identifier: string | null | undefined;
  readonly paymentMethods: ReadonlyArray<{
    readonly brCode?: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChargePrintPDF_charge" | "PaymentLinkActiveCashbackFidelityBalance_charge" | "PaymentLinkActiveEarnCashbackFidelity_charge" | "PaymentLinkActiveEarnCashback_charge" | "PaymentLinkActiveEarnDiscount_charge" | "PaymentLinkActiveInterestsSettings_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentLinkShareButton_charge" | "PaymentMethodPaymentDeadline_charge" | "PaymentMethodPixQrCode_charge" | "PaymentMethodPixValue_charge" | "PaymentMethodSelectedCustomerRegister_charge" | "PaymentMethodTransactionDetails_charge" | "useChargePaymentMethod_charge">;
  readonly " $fragmentType": "PaymentMethodPixSelected_charge";
};
export type PaymentMethodPixSelected_charge$key = {
  readonly " $data"?: PaymentMethodPixSelected_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodPixSelected_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brCode",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodPixSelected_charge",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerRegister",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "fitIn",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(fitIn:true)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/)
          ],
          "type": "PaymentMethodPix",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPixValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnDiscount_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashback_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveCashbackFidelityBalance_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashbackFidelity_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkShareButton_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveInterestsSettings_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useChargePaymentMethod_charge",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availablePaymentMethods",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v1/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "valueWithDiscount",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodPix",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/)
              ],
              "type": "PaymentMethodInstallments",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "installmentNumber",
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "type": "PaymentMethodCreditCard",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "consentId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authorizationUrl",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodITP",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoBarcode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoDigitable",
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "type": "PaymentMethodBoleto",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPixQrCode_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPaymentDeadline_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedCustomerRegister_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChargePrintPDF_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "c65940af51f655a58eeff4afd31c77e5";

export default node;
